// packages/shared-hooks/src/lead-tasks/useCreateLeadTask.ts
//
// `POST /lead-tasks` — a manager creating their own free-form MANUAL
// self-task (#1803/#1804). The backend forces `kind=MANUAL`,
// `stageEntryCode=NULL`, and `assigneeId=actor`; the caller only chooses
// the target lead, the title, and an optional due anchor. Success
// invalidates the whole `lead-tasks` prefix so the per-lead list, My Day,
// and Attention all pick up the new row without a manual refetch.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LeadTaskSchema, type CreateLeadTaskInput, type LeadTask } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadTasksKeys } from './keys.js';

export function useCreateLeadTask() {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LeadTask, unknown, CreateLeadTaskInput>({
    mutationFn: (input) => client.post<LeadTask>('/lead-tasks', input, {}, LeadTaskSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadTasksKeys.all });
    },
  });
}
